import React from "react";
import api from "@/services/api.js";
import toast from "react-hot-toast";
import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";

const PendingRequests = ({ requests, onRefresh }) => {
  const { t } = useTranslation();

  const handleAccept = async (friendshipId) => {
    try {
      await api.put(`/friendships/${friendshipId}/accept`);
      toast.success(t("pendingRequest_acceptSuccess"));
      onRefresh();
    } catch {
      toast.error(t("pendingRequest_acceptError"));
    }
  };

  const handleDecline = async (friendshipId) => {
    try {
      await api.delete(`/friendships/${friendshipId}`);
      toast.success(t("pendingRequest_declineSuccess"));
      onRefresh();
    } catch {
      toast.error(t("pendingRequest_declineError"));
    }
  };

  if (requests.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-48 gap-2 text-center border border-white/8 rounded-xl">
        <span className="text-zinc-500 text-sm">{t("pendingRequest_emptyTitle")}</span>
        <span className="text-zinc-600 text-xs">{t("pendingRequest_emptyDescription")}</span>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {requests.map((request) => (
        <div
          key={request.id}
          className="flex items-center justify-between px-4 py-3 rounded-xl border border-white/8 hover:bg-white/3 transition-colors"
        >
          {/* Avatar + info */}
          <div className="flex items-center gap-3">
            <div className="relative">
              {request.sender.avatarPath ? (
                <img
                  src={request.sender.avatarPath}
                  alt={request.sender.username}
                  className="w-9 h-9 rounded-full object-cover"
                />
              ) : (
                <div className="w-9 h-9 rounded-full bg-zinc-700 flex items-center justify-center text-zinc-300 text-sm font-medium">
                  {request.sender.username?.charAt(0).toUpperCase()}
                </div>
              )}
            </div>
            <div className="flex flex-col">
              <span className="text-sm text-white font-medium">{request.sender.username}</span>
              <span className="text-xs text-zinc-500">{t("pendingRequest_wantsToBeFriend")}</span>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2">
            <button
              onClick={() => handleAccept(request.id)}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs text-green-400 hover:bg-green-400/10 border border-transparent hover:border-green-400/20 transition-all"
            >
              <Check size={14} />
              {t("pendingRequest_acceptButton")}
            </button>
            <button
              onClick={() => handleDecline(request.id)}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs text-zinc-500 hover:text-red-400 hover:bg-red-400/10 border border-transparent hover:border-red-400/20 transition-all"
            >
              <X size={14} />
              {t("pendingRequest_declineButton")}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PendingRequests;